import { useEffect, useRef } from "react";
import { supabase } from "@/integrations/supabase/client";

/**
 * Lê o ghost_mode do perfil e mantém uma referência viva.
 * Usa ref (não state) porque o consumidor é um loop de tracking e não
 * precisa re-renderizar a cada mudança.
 */
export const useGhostModeAware = (userId: string | undefined) => {
  const ghostModeRef = useRef<boolean>(false);

  useEffect(() => {
    if (!userId) {
      ghostModeRef.current = false;
      return;
    }
    let cancelled = false;
    void supabase
      .from("profiles")
      .select("ghost_mode")
      .eq("id", userId)
      .maybeSingle()
      .then(({ data }) => {
        if (cancelled) return;
        ghostModeRef.current = Boolean(data?.ghost_mode);
      });
    return () => {
      cancelled = true;
    };
  }, [userId]);

  return ghostModeRef;
};
